export default __webpack_public_path__ + "static/media/re-soft-logo_2.8d824abe.png";